import {enqueueSnackbar} from 'notistack'
import {ChangeEvent, Dispatch, FC, SetStateAction, useRef, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {KTSVG} from '../../../../../../../../_metronic/helpers'
import {KTableLoading} from '../../../../../../components/UI'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {createBookingDocumentsService} from '../../../../services/booking.service'
import {getSnackBarToast} from '../../../../../../util/snackBar'

interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  getAttachmentDocuments: () => void
}

const ModalEditAttachmentDocuments: FC<Props> = ({show, setShow, getAttachmentDocuments}) => {
  const handleClose = () => {
    setShow(false)
  }

  const [file, setFile] = useState<File | null>(null)
  const [, setFileName] = useState<File | null>(null)
  const [error, setError] = useState('')
  const fileInputRef = useRef<HTMLInputElement | null>(null)
  const [loading] = useState(false)
  const {currentTabItem} = useHoteleria()

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const selectedFile = event.target.files?.[0]
    setFile(selectedFile || null)
    setFileName(selectedFile || null)
    setError('')
  }

  const getSnackBar = (message: String, variant: boolean) => {
    enqueueSnackbar(message, {
      variant: variant ? 'success' : 'error',
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
      },
    })
  }

  const handleUpload = async () => {
    try {
      if (file) {
        setError('')

        ///

        const formData = new FormData()
        formData.append('file', file)

        const response = await createBookingDocumentsService(formData, currentTabItem?.idToEdit) // Use the service to upload the file
        if (!response.data.error) {
          handleClose()
          getAttachmentDocuments()
          getSnackBarToast('Documento cargado correctamente', 'success')
        } else {
          setShow(true)
          // const error = response?.data?.data || []
          // setResponse(error)
          getSnackBarToast(response.data.message, 'error')
        }
      } else {
        setError('Este campo es requerido')

        console.error('No file selected.')
      }
      if (fileInputRef.current) {
        fileInputRef.current.value = '' // Borra la selección de archivo
      }
      setFile(null)
    } catch (error) {
      getSnackBarToast('Hubo un error', 'error')
    }
  }

  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-xl'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>Adjuntar Archivo</h5>

          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <form>
            <div className='mb-2 col-sm-12 col-md-6 col-lg-4'>
              <label className='required form-label'>Examinar</label>
              <div className='input-group input-group-sm'>
                <input
                  className='form-control'
                  type='file'
                  id='formFileRoom'
                  onChange={handleFileChange}
                  ref={fileInputRef}
                />
              </div>
              {error && <p className='error-message'>{error?.toString()}</p>}
            </div>
            <div className='p-6'>
              <div className='d-flex'>
                <div className='col-6'>
                  {/* <div className='mb-2 col-sm-12 col-lg-12'>
                    <label className='required'>Tipo de Nota:</label>
                    <Select control={control} name='TipoNotaId' data={[]} errors={errors} />
                  </div> */}
                </div>
                <div className='col-6'>
                  {/* <div className='mb-2 col-12'>
                    <label className='required form-label'>Nota</label>
                    <div
                      className='input-group input-group-sm'
                      style={{
                        width: '97%',
                      }}
                    >
                      <textarea className='form-control w-95' {...register('Descripcion')} />
                    </div>
                    <p
                      style={{
                        marginBottom: '0',
                        fontSize: '10px',
                        fontWeight: '600',
                        color: 'red',
                        marginLeft: '5px',
                      }}
                    >
                      {errors.Descripcion?.message}
                    </p>
                  </div> */}
                </div>
              </div>
            </div>

            {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
            <div className='d-flex justify-content-center mb-3'>
              <button type='button' className='btn btn-light-primary me-5' onClick={handleClose}>
                Cancelar
              </button>
              <button type='button' className='btn btn-primary' onClick={handleUpload}>
                Guardar
              </button>
            </div>
          </form>
          {loading ? <KTableLoading title='Cargando...' /> : null}
        </div>
      </div>
    </Modal>
  )
}

export {ModalEditAttachmentDocuments}
